import React from 'react'

const NewDownloadIcon = () => {
  return (
    <div className="imageContainerBtn codeBlockButton">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        className="downloadIcon-svg"
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: 'pointer' }}
      >
        <path
          d="M23.9978 14C24.5501 14 24.9978 14.4477 24.9978 15L24.9978 25.5903L27.2929 23.2951C27.6834 22.9046 28.3166 22.9046 28.7071 23.2951C29.0977 23.6857 29.0977 24.3188 28.7071 24.7094L24.712 28.7045C24.3176 29.0989 23.6781 29.0989 23.2836 28.7045L19.2885 24.7094C18.898 24.3188 18.898 23.6857 19.2885 23.2951C19.679 22.9046 20.3122 22.9046 20.7027 23.2951L22.9978 25.5902L22.9978 15C22.9978 14.4477 23.4455 14 23.9978 14Z"
          className="inner"
          fill="#003087"
        />
        <path
          d="M15 25C15 24.4477 15.4477 24 16 24C16.5523 24 17 24.4477 17 25V31H31V25C31 24.4477 31.4477 24 32 24C32.5523 24 33 24.4477 33 25V32C33 32.5523 32.5523 33 32 33H16C15.4477 33 15 32.5523 15 32V25Z"
          className="inner"
          fill="#003087"
        />
      </svg>
    </div>
  )
}

export default NewDownloadIcon
